import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-tag-bullet-list',
  templateUrl: './tag-bullet-list.component.html',
  styleUrls: ['./tag-bullet-list.component.scss']
})
export class TagBulletListComponent {
  @Input() items: String[];
  @Input() anchorClass: string; /*AnchorClass Exists To Modify Css IE11 Hack*/
}
